import React from "react";

export function inferDatatype(value) {
  if (value === null || value === undefined) {
    return "string";
  }

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return "date";
  }

  if (typeof value === "boolean") {
    return "boolean";
  }

  if (typeof value === "number") {
    return Number.isInteger(value) ? "number" : "decimal";
  }

  const text = String(value).trim();
  if (!text) {
    return "string";
  }

  if (/^(true|false)$/i.test(text)) {
    return "boolean";
  }

  if (/^-?\d+(\.\d+)?$/.test(text)) {
    return Number.isInteger(Number(text)) ? "number" : "decimal";
  }

  const parsedDate = Date.parse(text);
  if (!Number.isNaN(parsedDate) && text.length >= 4) {
    return "date";
  }

  return "string";
}

export default function FileUploadRenderer({ fileName, onUpload }) {
  const inputRef = React.useRef(null);

  const handleChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      onUpload(file);
    }
    event.target.value = "";
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.35rem" }}>
      <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", flexWrap: "wrap" }}>
        <input
          ref={inputRef}
          type="file"
          accept=".csv,.xlsx,.xls"
          onChange={handleChange}
          style={{ display: "none" }}
        />
        <button
          type="button"
          className="cfg-btn cfg-btn-sm"
          onClick={() => inputRef.current?.click()}
        >
          Choose file
        </button>
        <span style={{ fontSize: "0.75rem", color: fileName ? "#111" : "#888" }}>
          {fileName || "No file selected"}
        </span>
      </div>
      <div style={{ fontSize: "0.68rem", color: "#666" }}>
        Supported formats: CSV, XLSX, XLS
      </div>
    </div>
  );
}
